import { BaseEditModel } from "model/BaseEditModel";
import Estagio from "./Estagio";
import Roteiro from "./Roteiro";

export default class EstagioRoteiro implements BaseEditModel {
    id: number;
    codigo: string = "";
    key: string = "";
    sequencial: number;
    sequenciaPosicionamento: number;
    estagio: Estagio;
    roteiro: Roteiro;

    constructor(
        id: number = 0, 
        sequencial: number = 0,
        sequenciaPosicionamento: number = 0,
        estagio: Estagio = new Estagio(),
        roteiro: Roteiro = new Roteiro()
    ) {
        this.id = id;
        this.sequencial = sequencial;
        this.sequenciaPosicionamento = sequenciaPosicionamento;
        this.estagio = estagio;
        this.roteiro = roteiro;
    }
}